import React, { Component } from "react";
import { Helmet } from "react-helmet";

type FontItem = {
  src: string;
};

type FontHeaderProps = {
  media?: {
    text: string;
  };
  fonts?: FontItem[];
};

export class FontHeader extends Component<FontHeaderProps> {
  render() {
    const { media, fonts = [] } = this.props;

    return (
      <Helmet>
        {media?.text && <style>{media.text}</style>}
        {fonts.map((item, i) => (
          <link href={item.src} rel="stylesheet" key={i} />
        ))}
      </Helmet>
    );
  }
}
